export const svfi = {

    common: {
        DocumentID: "Fakturanummer",
        DocumentDate: "Fakturadatum",
        CreatedDate: "Behandlingsdatum",
        ReceiverName: "Mottagarens namn",
        SenderName: "Fakturerare",
        DueDate: "Förfallodatum",
        AmountToPay: "Summa",
        showing: "Showing",
        image: "Bild",
        xml: "Data/XML",
        bankAccount: "Kontonummer",
        orderReference: "Beställningsreferens",
        paymentReference: "Betalningsreferens",
        paymentStatus: "Betalningsstatus",
        transferStatus: "Transferstatus",
        approvalStatus: "Godkännandestatus",
        documentName: "Document namn",
        imageName: "Bild namn",
        perPage: "Resultat per sida",
        reset: "Återställ",
        select: "Välj",
        sent: "Skickade",
        received: "Mottagna",
        today: "Idag",
        yesterday: "Igår",
        last7: "Senaste 7 dagarna",
        last30: "Senaste 30 dagarna",
        last60: "Senaste 60 dagarna",
        currMonth: "Nuvarande månad",
        lastMonth: "Förra månaden",
        custom: "Anpassa",
        instructions1: "Filtrera och ordna resultaten enligt rubriker",
        instructions2: "Göm kolumnerna och ställ in antal resultat i inställningarna",
        files: "Filer",
        daysShort: {
            su: "Sö",
            mo: "Må",
            tu: "Ti",
            we: "On",
            th: "To",
            fr: "Fr",
            sa: "Lö"
        },
        monthNames: {
            january: "Januari",
            february: "Februari",
            march: "Mars",
            april: "April",
            may: "Maj",
            june: "Juni",
            july: "Juli",
            august: "Augusti",
            september: "September",
            october: "Oktober",
            november: "November",
            december: "December"
        }
    },
    texts: {
        count: "Showing {from}-{to} results|{count} Results|One result",
        filter: "Filter:",
        filterPlaceholder: "Search",
        limit: "Results:",
        page: "Page:",
        noResults: "Inga resultat",
        loading: "Söker...",
        filterBy: "Hae {column}illa",
        defaultOption: "Select {column}"
    },
    errors: {
        DocumentDate: "Matchar inte dd.mm.åååå - dd.mm.åååå",
        CreatedDate: "Matchar inte dd.mm.åååå - dd.mm.åååå",
        DueDate: "Matchar inte dd.mm.åååå - dd.mm.åååå",
        AmountToPay: "Värdet är inte ett nummer",
        daysOverLimit: "Tidsperioden överstiger {days} dagar",
        requiredField: "Fältet är obligatoriskt"
    },
    file: {
        download: "Ladda ner",
        upload: "Ladda upp",
        delete: "Radera",
        rename: "Byt namn",
        createFolder: "Ny folder",
        name: "Namn",
        size: "Storlek",
        modified: "Ändrad",
        save: "Spara",
        cancel: "Avbryt",
        error: "Fel",
        nameExists: "Objekt med samma namn finns redan",
        undefinedError: "Okänt fel",
        ok: "Ok",
        backward: "Föregående",
        forward: "Nästa",
        nameTooLong: "Den maximala längden för namn är 80 tecken",
        tooLarge: "Filen måste vara under 50 MB",
        unknownType: "Okänd filtyp",
    }
}